<app-sidebar>
  <div class="platform-stats-page">
    <div class="page-header">
      <h1>Platform Stats</h1>
      <button mat-stroked-button type="button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>

    <div *ngIf="loading" class="stats-loading-state">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Loading platform stats...</p>
    </div>

    <ng-container *ngIf="!loading && stats">
      <div class="metrics-grid">
        <div
          class="metric-card"
          *ngFor="let card of metricCards"
          [matTooltip]="card.tooltip || ''"
          [matTooltipDisabled]="!card.tooltip">
          <div class="metric-label">{{ card.label }}</div>
          <div class="metric-value">{{ card.value }}</div>
          <div class="metric-hint" *ngIf="card.hint">{{ card.hint }}</div>
        </div>
      </div>

      <div class="charts-grid">
        <div class="chart-card">
          <div class="chart-header">
            <h2>Lookups per Day (30d)</h2>
          </div>
          <div class="bars" *ngIf="lookupsDaily30d.length > 0">
            <div class="bar-wrap" *ngFor="let point of lookupsDaily30d; trackBy: trackByDay">
              <div class="bar-value">{{ point.lookups }}</div>
              <div class="bar-column">
                <div class="bar lookups" [style.height]="getBarHeight(point.lookups, lookupsDailyMax)"></div>
              </div>
              <div class="bar-label">{{ formatDayLabel(point.day) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-card failure-card">
        <div class="chart-header">
          <h2>Top Failure Reasons (30d)</h2>
        </div>
        <div class="failure-list" *ngIf="stats.failureReasons30d.length > 0">
          <div class="failure-row" *ngFor="let item of stats.failureReasons30d">
            <div class="failure-reason">{{ item.reason }}</div>
            <div class="failure-count">{{ item.count }}</div>
          </div>
        </div>
        <p class="empty-message" *ngIf="stats.failureReasons30d.length === 0">No failed requests in the last 30 days.</p>
      </div>
    </ng-container>
  </div>
</app-sidebar>
